import { ProductTypeEnum, defaultPhysicalProductValues } from '@systemeio/digital-store-shared'
import { PhysicalProductItemEditType } from '../../types/product-interface'

export const defaultValues: PhysicalProductItemEditType = {
  ...defaultPhysicalProductValues,
  draft: false,
  productType: ProductTypeEnum.physicalProduct,
  checkoutPage: {
    fields: [],
    title: '',
    buttonTitle: '',
    description: '',
    cover: null,
    offerId: null,
    physicalProductId: undefined,
  },
  thankYouPage: {
    title: '',
    text: '',
  },
}
